var bgVideoComponent = function ($) {

    var $container;
    var YTPlayer = require('luminoslabs/_yt-player');

    function setCoverImage(videoId, $coverImageElem, videoType, fallbackImgUrl) {
        var devicePixelRatio = window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI,
            windowWidth = $(window).width(),
            thumbnailWidth = Math.round(devicePixelRatio * windowWidth);

        switch (videoType) {
            case 'vimeo':
                setVimeoCover(videoId, $coverImageElem, thumbnailWidth, fallbackImgUrl);
                break;
            case 'youtube':
                setYoutubeCover(videoId, $coverImageElem, thumbnailWidth, fallbackImgUrl);
                break;
        }
    }

    function setVimeoCover(videoId, $coverImageElem, thumbnailWidth, fallbackImgUrl) {
        $.ajax({
            type: 'GET',
            url: 'https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/' + videoId + '&width=' + thumbnailWidth,
            dataType: 'json',
        })
        .done(function (data) {
            $coverImageElem.css('background-image', 'url(' + data.thumbnail_url + ')');
        })
        .fail(function () {
            $coverImageElem.css('background-image', 'url(' + fallbackImgUrl + ')');
        });
    }

    function setYoutubeCover(videoId, $coverImageElem, thumbnailWidth, fallbackImgUrl) {
        var imgType;
        var imgUrl;

        $.ajax({
            type: 'GET',
            url: 'https://www.googleapis.com/youtube/v3/videos',
            data: {
                key: 'AIzaSyDqjaX9ly_IMTWOsDLiKddLpT4WW7qWDkU',
                id: videoId,
                part: 'snippet'
            },
            dataType: 'json',
            cache: false
        })
        .done(function (data) {
            var thumbnail = chooseYoutubeThumbnail(data.items[0].snippet.thumbnails, thumbnailWidth);
            $coverImageElem.css('background-image', 'url(' + thumbnail.url + ')');
        })
        .fail(function () {
            $coverImageElem.css('background-image', 'url(' + fallbackImgUrl + ')');
        });
    }

    function downloadVimeoVideo($iframeWrapper, $iframe) {
        $iframe.attr('src', $iframe.attr('data-src'));
        var player = new Vimeo.Player($iframe[0]);
        player.on('timeupdate', videoLoaded);

        function videoLoaded() {
            $iframeWrapper.addClass('video-loaded');
            player.off('timeupdate', videoLoaded);
        }
    }

    function downloadYoutubeVideo($iframeWrapper, $iframe, videoId) {
        var opts = {
            width: 1280,
            height: 720,
            autoplay: true,
            controls: false,
            keyboard: false,
            fullscreen: false,
            annotations: false,
            modestBranding: true,
            related: false,
            info: false,
            loop: true,
            start: 0
        };

        var ytElem = $iframeWrapper.find('.bg-video__iframe');

        var player = new YTPlayer(ytElem[0], opts);
        player.load(videoId);
        player.setVolume(0);

        player.on('playing', function(e) {
            $iframeWrapper.addClass('video-loaded');
        });
    }

    function chooseYoutubeThumbnail(thumbnails, thumbnailWidth) {
        var thumbnail;

        if (thumbnailWidth <= 480) {
            thumbnail = thumbnails.medium;
        } else if (thumbnailWidth <= 640) {
            thumbnail = thumbnails.high;
        } else if(thumbnailWidth <= 991) {
            thumbnail = thumbnails.standard;
        } else {
            thumbnail = thumbnails.maxres;
        }

        return thumbnail;
    }

    function init() {
        $container = $('.bg-video');
        $container.each(function () {
            var $this = $(this);
            var $iframeWrapper = $this.find('.bg-video__iframe-wrapper');

            var $iframe = $iframeWrapper.find('iframe');
            var videoId = $this.attr('data-video-id');
            var videoType = $this.attr('data-video-type');
            var $coverImageElem = $this.find('.bg-video__cover-img');
            var fallbackImgUrl = $coverImageElem.attr('data-fallback-img');

            if (videoId) {
                if ($(window).width() >= 769) {

                    setCoverImage(videoId, $coverImageElem, videoType, fallbackImgUrl);

                    switch (videoType) {
                        case 'vimeo':
                            downloadVimeoVideo($iframeWrapper, $iframe);
                            break;
                        case 'youtube':
                            downloadYoutubeVideo($iframeWrapper, $iframe, videoId);
                            break;
                    }
                } else {
                    var $overlayBlock = $this.find('.generic-overlay');
                    var overlayClassList = $overlayBlock.attr('class');
                    if (overlayClassList.indexOf('bg-') === -1 || overlayClassList.indexOf('bg-transparent') >= 0) {
                        overlayClassList = overlayClassList.replace('bg-transparent', '');
                        $overlayBlock.attr('class', overlayClassList);
                        setCoverImage(videoId, $overlayBlock, videoType, fallbackImgUrl);
                    }
                }
            }
        });
    }

    return {
        init: init
    };
}(jQuery);

$(function () {
    bgVideoComponent.init();
});